exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".intro-text{margin-bottom:0}", "", {"version":3,"sources":["/tmp/build_03dca47f/app/javascript/errors/styles/main.scss"],"names":[],"mappings":"AAGA,YACE,eAAA,CAAA","file":"main.scss","sourcesContent":["// Place all the styles related to the errors controller here.\n// They will automatically be included in application.css.\n// You can use Sass (SCSS) here: http://sass-lang.com/\n.intro-text {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports
